import Link from 'next/link';
import Image from 'next/image';
import React from 'react';

function BlogArticleSuggestion({ direction, article }) {
    return (
        <Link href={`/blog/articles/${article.slug}`}>
            <a className="flex flex-row flex-grow h-32 btn trust-border mb-4 mx-2 lg:mx-0 w-full sm:max-w-[45%] sm:w-auto lg:max-w-none lg:flex-grow-0 lg:w-full relative rounded-lg overflow-hidden opacity-100 lg:opacity-50 hover:opacity-100">
                <div className="flex absolute z-20 top-0 flex-row p-4 w-full h-full">
                    <div
                        className={`flex w-1/5 items-center justify-center ${
                            direction === 'right' ? 'order-2' : ''
                        }`}
                    >
                        <i className={`text-maturity-500 text-[2rem] flaticon-${direction}-arrow`}></i>
                    </div>
                    <div className="flex flex-col w-4/5 items-start justify-center">
                        <h4 className="text-sm normal-case ">{article.title}</h4>
                        <span className="text-xxs text-maturity-300">{article.estimate} mins read</span>
                    </div>
                </div>
            </a>
        </Link>
    );
}

export default BlogArticleSuggestion;
